// src/pages/WishlistPage.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import "./WishlistPage.css";

export default function WishlistPage() {
  const { wishlist, toggleWishlist, addItem } = useCart();
  const navigate = useNavigate();

  return (
    <div className="wishlist-page">
      <div className="container">
        <h1 className="wishlist-page__title">MY WISHLIST ({wishlist.length})</h1>
        {wishlist.length === 0 ? (
          <div className="wishlist-empty">
            <div style={{ fontSize: 64, marginBottom: 20 }}>🤍</div>
            <h3>Your wishlist is empty</h3>
            <p>Save your favourite items here and shop when you're ready</p>
            <button onClick={() => navigate("/")}>EXPLORE PRODUCTS</button>
          </div>
        ) : (
          <div className="wishlist-grid">
            {wishlist.map(item => (
              <div key={item.id} className="wishlist-card">
                <div className="wishlist-card__img-wrap" onClick={() => navigate(`/product/${item.id}`)}>
                  <img src={item.img} alt={item.name} />
                  <button className="wishlist-card__remove" onClick={e => { e.stopPropagation(); toggleWishlist(item); }}>✕</button>
                </div>
                <div className="wishlist-card__body">
                  <p className="wishlist-card__brand">{item.brand}</p>
                  <p className="wishlist-card__name">{item.name}</p>
                  <div className="wishlist-card__price-row">
                    <span className="wishlist-card__price">₹ {item.price.toLocaleString()}</span>
                    {item.mrp > item.price && <span className="wishlist-card__mrp">₹ {item.mrp.toLocaleString()}</span>}
                  </div>
                  <button className="wishlist-card__add" onClick={() => { addItem({ ...item, selectedSize: item.sizes[2] || item.sizes[0], selectedColor: item.colors[0] }); toggleWishlist(item); navigate("/cart"); }}>
                    MOVE TO BAG
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
